module.exports = __webpack_public_path__ + "img/arrow.93a65ba4.svg";